import React, { useMemo } from 'react';

import _ from 'lodash';
import Select from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';

export default function SingleValueSelector({ onChange, value, canCreate, options, placeholder, isClearable, ...props }) {
  const handleSelectChange = (op, actionMeta) => onChange(op?.value);    

  const getOption = (props) => {
    let { innerProps, isSelected, isFocused } = props;
    let { innerRef, ...filteredProps } = innerProps;
    return <div {...filteredProps} className={'p-1 ' + ((isSelected || isFocused) ? 'bg-light-primary bg-med' : '')}>
      {props.label}
    </div>;
  };

  const getMultiValueLabel = (props) => props.children;

  const optionsObjects = useMemo(() => _.map(options, (op) => {
    if (op.value && op.label) {
      return { label: op.label, value: op.value };
    } else {
      return { label: op.toString(), value: op };
    }
  }), [options]);

  let valueOption = _.find(optionsObjects, op => op.value === value);
  if (value && !valueOption) {
    valueOption = { label: value.toString(), value: value };
  }

  const ClassName = canCreate ? CreatableSelect : Select;
  return (
    <ClassName closeOnSelect={true}
            components={{ Option: getOption, MultiValueLabel: getMultiValueLabel }}
            onChange={handleSelectChange}
            options={optionsObjects}
            menuShouldScrollIntoView={false}
            placeholder={placeholder || "None"}
            isClearable={true}
            value={valueOption}
            {...props}
    />
  );
}

